module.exports = __webpack_public_path__ + "static/media/logo.d1e1ca27.png";